import { FleekError } from './FleekError';

export class ApplicationsNotFoundError extends FleekError<object> {
  public name = 'ApplicationsNotFoundError';

  toString = () => 'No applications found.';
}
